/* 
Generic satellite

footPrintsStyle  "none" "rect" "ellipse"
satelliteStyle = "detailed" "cube"
color       cube style: applies color to cube.  detailed style: "gray" makes body & panels gray, all others make blue and gold.
satelliteSize
dispose()
*/

import * as THREE from 'three';
import UtilSP from 'SATPROF_UTILS/UtilSP';
import { namespaceTypeNames } from '@awayfl/avm2/dist/lib/abc/lazy/NamespaceType';
//import SphericalSectionGeometry_geom from 'SATPROF_LIBRARY/ThreeDParts/SphericalSectionGeometry_geom';

export default class Satellite3D2_grp  extends THREE.Group{
   

    private body:THREE.Group;
    private body_m:THREE.Mesh;
    private _bodyWidth_m:number = 1; // Size of cube
    private _bodyThickness_m:number = 1; // Size of cube

    private panels:THREE.Group;
    private panel1_m:THREE.Mesh;
    private panel2_m:THREE.Mesh;
    private _panelLength:number = 5;
    private _panelWidth:number = .8;
    private _panelThickness:number = .1;
    private _panelColor:string = "blue";


    private GWantennas:THREE.Group;
    private gwAnt1_m:THREE.Mesh;
    private gwAnt2_m:THREE.Mesh;
    private _GWdishColor:string = "white";


    private satellite:THREE.Group;
    private _satelliteSize:number = 100;
    private _bodyColor:string = "red";
    private _displayScale:number = 1;
    private _orientation_deg:number = 0;

    private _satelliteStyle:string = "cube";
    private groupA:THREE.Group;
    private groupB:THREE.Group;
    private groupC:THREE.Group;

    private _satName:string = "";
    private _color:string = "";

    constructor(){
        super();
        //console.log("In Satellite3D2_grp constructor...")
        this.createObject();
    }
    
        
    private createObject(){

        this.groupA = new THREE.Group();
        this.groupB = new THREE.Group();
        this.groupC = new THREE.Group();
        this.add(this.groupA);
        this.groupA.add( this.groupB);
        this.groupB.add( this.groupC);

        // Initialize all groups and meshes:
        this.satellite = new THREE.Group();
        this.groupC.add(this.satellite);

        this.body = new THREE.Group();
        this.body_m = new THREE.Mesh();
        this.satellite.add(this.body);
        this.body.add(this.body_m);

        this.panels = new THREE.Group();
        this.satellite.add(this.panels);
        this.panel1_m = new THREE.Mesh();
        this.panel2_m = new THREE.Mesh();
        this.panels.add(this.panel1_m);
        this.panels.add(this.panel2_m);

        this.GWantennas = new THREE.Group();
        this.satellite.add(this.GWantennas);
        this.gwAnt1_m = new THREE.Mesh();
        this.gwAnt2_m = new THREE.Mesh();
        this.GWantennas.add(this.gwAnt1_m);
        this.GWantennas.add(this.gwAnt2_m);

        // let satelliteHelper:THREE.AxesHelper = new THREE.AxesHelper( 20000 );
        // this.satellite.add( satelliteHelper );


        this.rebuildSatellite();
    }
    public disposeAll(){
        this.disposeMesh(this.body_m);
        this.disposeMesh(this.panel1_m); 
        this.disposeMesh(this.panel2_m); 
        this.disposeMesh(this.gwAnt1_m); 
        this.disposeMesh(this.gwAnt2_m);       
    }
    private disposeMesh(meshObj){
        meshObj.geometry.dispose();
        if (meshObj.material instanceof THREE.Material) {
            meshObj.material.dispose()
        } else if (Array.isArray(meshObj.material)) {
            for (const material of meshObj.material) {
                material.dispose()
            }
        } 
    }
    private rebuildSatellite(){
        this.body.visible = false;
        this.panels.visible = false;
        this.GWantennas.visible = false;
        switch (this._satelliteStyle){
            case "cube":
                this.buildCubicalSat();
                break;
            case "detailed":
                this.buildDetailedSat();
                break;
        }
    }
    private buildCubicalSat(){
        let w:number = this._satelliteSize * this._bodyWidth_m;
        if (this._color == "bluegold"){
            this._bodyColor = "gold";
        } else {
            this._bodyColor = this._color;
        }
        let body_g:THREE.BoxGeometry = new THREE.BoxGeometry(w, w, w);
        let body_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial( { color: this._bodyColor } );
        UtilSP.replaceMeshGeometry(this.body_m, body_g);
        UtilSP.replaceMeshMaterial(this.body_m, body_mat);
        this.body.visible = true;

    }
    // Moved these to UtilSP.
    // public replaceMeshGeometry(mesh:THREE.Mesh, newGeom:any):void{
    //     if (mesh.geometry){
    //         mesh.geometry.dispose(); 
    //     }
    //     mesh.geometry = newGeom;
    // }
    // public replaceMeshMaterial(mesh:THREE.Mesh, newMat:THREE.Material):void{
    //     if (mesh.material instanceof THREE.Material) {
    //         mesh.material.dispose()
    //     } else if (Array.isArray(mesh.material)) {
    //         for (const material of mesh.material) {
    //             material.dispose()
    //         }
    //     }        
    //     mesh.material = newMat;
    // }    
    private buildDetailedSat(){
        //debugger
        if (this._color == "bluegold"){
            this._bodyColor = "gold";
            this._panelColor = "blue";
            this._GWdishColor = "white";
        } else {
            this._bodyColor = this._color;
            this._panelColor = this._color;
            this._GWdishColor = this._color;
        }

        let body_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial( { color: this._bodyColor } );
        let panel_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial( { color: this._panelColor } );
        let gwAnt_mat:THREE.MeshPhongMaterial = new THREE.MeshPhongMaterial( { color: this._GWdishColor, side: THREE.DoubleSide } );


        let w:number = this._satelliteSize;
        this._bodyWidth_m = w;
        let cube_g:THREE.BoxGeometry = new THREE.BoxGeometry(w, w, w);
        UtilSP.replaceMeshGeometry(this.body_m, cube_g);
        UtilSP.replaceMeshMaterial(this.body_m, body_mat);

        // let panelHeight:number = 1500;
        // let panelWidth:number = 1500;
        // let panelThickness:number = 10;
        this._panelThickness = 0.1 * w;
        this._panelWidth = 0.7 * w;
        this._panelLength = 2 * w;
        let panel_g:THREE.BoxGeometry = 
            new THREE.BoxGeometry(this._panelThickness, this._panelWidth, this._panelLength, 10, 10, 10); //
        this.panels.add(this.panel1_m);
        this.panels.add(this.panel2_m);
        this.panel1_m.position.z = w/2 + this._panelLength/2;
        this.panel2_m.position.z = -this.panel1_m.position.z;
        UtilSP.replaceMeshGeometry(this.panel1_m, panel_g);
        UtilSP.replaceMeshGeometry(this.panel2_m, panel_g);
        UtilSP.replaceMeshMaterial(this.panel1_m, panel_mat);
        UtilSP.replaceMeshMaterial(this.panel2_m, panel_mat);

        let gwAnt_g:THREE.CircleGeometry = new THREE.CircleGeometry(w/2,32);
        UtilSP.replaceMeshGeometry(this.gwAnt1_m, gwAnt_g);
        UtilSP.replaceMeshGeometry(this.gwAnt2_m, gwAnt_g);
        UtilSP.replaceMeshMaterial(this.gwAnt1_m, gwAnt_mat);
        UtilSP.replaceMeshMaterial(this.gwAnt2_m, gwAnt_mat);
        this.gwAnt1_m.position.y = w;
        this.gwAnt1_m.position.x = -w/2;
        this.gwAnt1_m.position.z = 0;
        this.gwAnt1_m.rotation.x = Math.PI/2;
        this.gwAnt1_m.rotation.y = UtilSP.radians(-70);
        //this.gw2_m = new THREE.Mesh(gwAnt_g, gwAnt_mat);
        this.gwAnt2_m.position.y = -this.gwAnt1_m.position.y;
        this.gwAnt2_m.position.x = this.gwAnt1_m.position.x;
        this.gwAnt2_m.position.z = this.gwAnt1_m.position.z;
        this.gwAnt2_m.rotation.x = this.gwAnt1_m.rotation.x;
        this.gwAnt2_m.rotation.y = -this.gwAnt1_m.rotation.y;            
        
        this.body.visible = true;
        this.panels.visible = true;
        this.GWantennas.visible = true;
        this.satellite.rotation.x = UtilSP.radians(90 + this._orientation_deg); // Default is transverse to panels axis
    }

    public set panelRotationDeg(val:number){
        this.panels.rotation.z = -UtilSP.radians(val);
    }
    public get panelRotationDeg(){
        return UtilSP.degrees(this.panels.rotation.z);
    }

    public set satelliteSize(val:number){
        this._satelliteSize = val;
        this.rebuildSatellite();

        // let scale:number = 1;
        // if (this._satelliteStyle == "detailed"){
        //     scale = val/1000; // Body was sized at 1000
        // } else {
        //     scale = val/100; // Cube geometry is 100
        // }

    }
    public get satelliteSize(){
        return this._satelliteSize;
    }
    public set satelliteDisplayScale(val:number){
        this._displayScale = val;
        this.satellite.scale.x = this._displayScale;
        this.satellite.scale.y = this._displayScale;
        this.satellite.scale.z = this._displayScale;
    
    }
    public get satelliteDisplayScale(){
        return this._displayScale;
    }
    public setPos(xpos:number, ypos:number, zpos:number, ta_deg:number, paramsObj:any){
        this.position.x = xpos;
        this.position.y = ypos;
        this.position.z = zpos;

        let raan_deg:number = paramsObj.Raan_deg;
        let incl_deg:number = paramsObj.incl_deg;
        //let isGEO:boolean = paramsObj.isGEO;  // Not needed
        /*
        x axis is along satellite pointing direction
        z axis is along solar panels
        y axis is up and down from body
        */

        // raan A  y
        // incl B x
        // ta  C y
        this.groupA.rotation.y =  UtilSP.radians(raan_deg); //
        this.groupB.rotation.x =  UtilSP.radians(incl_deg); //
        this.groupC.rotation.y =  UtilSP.radians(ta_deg - 90); // 

        //console.log("raan_deg = "+raan_deg+", ta_deg = "+ta_deg+", phiDeg= "+phiDeg);
        
    }
    public set satelliteStyle(val:string){
        //console.log("In Satellite3D2_grp. set satelliteStyle = "+val);
        if (val != "cube" && val != "detailed"){
            console.log("In Satellite3D2_grp, set detailed, invaled style ignored: "+val);
            return;
        }
        if (val == this._satelliteStyle) return; // No change

        this._satelliteStyle = val;
        this.rebuildSatellite();
    //     if (this._satelliteStyle == "detailed"){
    //         this.makeDetailedSatellite();
    //         this.body.visible = true;
    //         this.panels.visible = true;   
    //         this.cubeSat.visible = false;                 
    //    } else {
    //         UtilSP.clearThreeJSGroup(this.body);
    //         UtilSP.clearThreeJSGroup(this.panels);       
    //         this.body.visible = false;
    //         this.panels.visible = false;  
    //         this.cubeSat.visible = true;                  
    //     }
    }
    public get satelliteStyle(){
        return this._satelliteStyle ;
    }

    public set satName(val:string){
        this._satName = val;

    }
    public get satName(){
        return this._satName;
    }
    public set showAntennas(val:boolean){
        this.GWantennas.visible = val;
    }
    public get showAntennas(){
        return this.GWantennas.visible;
    }
    public set color(val:string){
        this._color = val;
        this.rebuildSatellite();
    }

}


